module.exports = __webpack_public_path__ + "static/shoe-black-b-23c1425363a4a96eb911963fee878b3c.png";